import axiosInterceptors from "../../axiosInterceptor/axiosInterceptor";
import { diseaseReportUrl } from "../../config/apiConfig";


export const getDiseaseReport = (data) => {
    return axiosInterceptors()
        .get(`${diseaseReportUrl}/?${data}`)
        .then(res=>res)
}